// Callsigns with LPs
const activeNetworks = {
  ATTPTHD: 'SportsNet Pittsburgh',
  ATTSWHD: 'Space City Home Network',
  BEIN1HD: 'beIN Sports',
  BETHD: 'BET',
  BTN: 'Big Ten Network',
  // BVO: 'Bravo', // TEMPORARY NBC DISPUTE
  CBS: 'CBS',
  CBSSN: 'CBS Sports Network',
  // TEMPORARY NBC DISPUTE
  // CNBC: 'CNBC',
  CCHD: 'Comedy Central',
  DEP: 'FOX Deportes',
  // EE: 'E!', // TEMPORARY NBC DISPUTE
  FNCHD: 'Fox News',
  FOX: 'FOX',
  FS1: 'FS1',
  FS2: 'FS2',
  // GLFC: 'Golf Channel', // TEMPORARY NBC DISPUTE
  MARQ: 'Marquee Sports Network',
  MASNHD: 'MASN',
  MLBHD: 'MLB Network',
  MSG: 'MSG',
  // TEMPORARY NBC DISPUTE
  // MSNBC: 'MSNBC',
  MTVHD: 'MTV',
  // TEMPORARY NBC DISPUTE
  // NBC: 'NBC',
  NESN: 'NESN',
  NFLHD: 'NFL Network',
  NHLNET: 'NHL Network™',
  NIKHD: 'Nickelodeon',
  RAIITA: 'RAI Italia',
  SNY: 'SNY',
  // TEMPORARY NBC DISPUTE
  // SYFY: 'Syfy',
  TENISHD: 'Tennis Channel',
  // TEMPORARY NBC DISPUTE
  // USAN: 'USA Network',
  VH1HD: 'VH1',
  WEATHHD: 'The Weather Channel',
  PRLITVGD: 'Premier League TV',
  YESHDNY: 'YES Network',
}

// Callsigns without LPs, but mights be used by affiliates
const extraNetworks = {
  AMC: 'AMC Network',
  BABYUS: 'Baby TV',
  BBC: 'BBC',
  BBCWN: 'BBC World News',
  BEINCHD: 'beIN Sports Canada',
  BTN2: 'Big Ten Network 2',
  CMTVHD: 'CMT',
  CNNHD: 'CNN',
  // DSCHD: 'Discovery Channel',
  FNESPRI: 'FOX Network East',
  FBNHD: 'FOX Business',
  FOXRSN: 'FOX Sports Network',
  IMGUCI: 'fubo Cycling',
  FXE: 'FX',
  FXM: 'FX Movie Channel',
  IFC: 'IFC',
  HALLHD: 'Hallmark Channel',
  HMMHD: 'Hallmark Movies & Mysteries',
  LOGOHD: 'Logo',
  MSG2: 'MSG2',
  // TEMPORARY NBC DISPUTE
  // NBCSN: 'NBC Sports Network',
  NICJRHD: 'Nick Jr.',
  // TEMPORARY NBC DISPUTE
  // OXG: 'Oxygen',
  PARHD: 'Paramount',
  TENISHS: 'Tennis Channel',
  TVLNDHD: 'TV Land',
  // TEMPORARY NBC DISPUTE
  // SPR: 'Universal Kids',
  VSIN: 'VSiN',
}

export const networkNames = {
  ...activeNetworks,
  ...extraNetworks,
}
